import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroSection = _resolveComponent("HeroSection")!
  const _component_CTACards = _resolveComponent("CTACards")!
  const _component_VisionMission = _resolveComponent("VisionMission")!
  const _component_OurWork = _resolveComponent("OurWork")!
  const _component_Testimonials = _resolveComponent("Testimonials")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeroSection),
    _createVNode(_component_CTACards),
    _createVNode(_component_VisionMission),
    _createVNode(_component_OurWork),
    _createVNode(_component_Testimonials)
  ]))
}